export const PRODUCT_ICONS = {
  rotavator: '⚙️',
  'disk-harrow': '🌾',
  mulcher: '🌿',
  'laser-land-leveller': '📐',
};

export const PRODUCT_COLORS = {
  rotavator: { bg: '#0A3F22', light: '#EAF2EC', accent: '#1B6B3D' },
  'disk-harrow': { bg: '#78350F', light: '#FEF3C7', accent: '#B45309' },
  mulcher: { bg: '#14532D', light: '#DCFCE7', accent: '#166534' },
  'laser-land-leveller': { bg: '#1E3A5F', light: '#DBEAFE', accent: '#1E40AF' },
  'fertilizer-spreader': { bg: '#92400E', light: '#FEF3C7', accent: '#B45309' },
  'potato-mulcher': { bg: '#713F12', light: '#FEF9C3', accent: '#92400E' },
  cultivator: { bg: '#14532D', light: '#DCFCE7', accent: '#166534' },
  'mini-rotavator': { bg: '#9A3412', light: '#FEF2E8', accent: '#C2410C' },
};

const S = "https://static.prod-images.emergentagent.com/jobs/2a6bfe0d-bf62-4b21-995b-6c2794398f74/images/";

// Real engineering features per product (from product catalog)
export const PRODUCT_FEATURES = {
  rotavator: [
    'High Tensile EN Steel Blades — L-Type, C-Type & Hammer Type',
    'Floating Gearbox System — Less Vibration, Better Suspension',
    'EN 353 Helical Side Gear — Maximum Torque, Longer Life',
    'Silicon Oil Seal — Dust & Moisture Proof for Extended Life',
    'Side Disc Assembly — Precise Edge Cutting & Stubble Removal',
    '3 Series: Regular (SRRG) | Max Pro (SRMP) | Max Pro Plus (SRMPP)',
  ],
  'disk-harrow': [
    'Boron Steel Discs — 18 to 24 Inch, Maximum Penetration Depth',
    'Gang Angle Adjustable — Set for Any Soil Type or Condition',
    'Heavy MS Box Frame — Engineered for High-Impact Stress',
    'Sealed Grease Bearings — Minimal Maintenance, Maximum Uptime',
    'Compatible with 40–75 HP Tractors, Standard 3-Point Hitch',
    'Performs in Dry, Wet, Compact & Residue-Heavy Soil',
  ],
  mulcher: [
    'Y-Type Hardened Steel Blades — Powerful Crop Residue Shredding',
    'Heavy Duty PTO Gearbox — 540 RPM with Overload Protection',
    'Full-Width Protective Hood — Safety Certified Design',
    'Roller Bearing Side Drives — Extended Service Life',
    'Adjustable Rear Deflector Flap — Control Discharge Direction',
    'Eliminates Stubble Burning — Enriches Soil Organic Matter',
  ],
  'fertilizer-spreader': [
    'Centrifugal Twin-Disc Spreading — Even 360° Coverage',
    'Heavy Duty Polyethylene Hopper — Rust & Corrosion Free',
    'Adjustable Spread Width: 6 to 12 Metres',
    'Suitable for Fertilizer, Seeds, Lime & Gypsum',
    'Stainless Steel Spreading Discs — Long Service Life',
    'Compatible with All 30–50 HP Tractors, 540 RPM PTO',
  ],
  'potato-mulcher': [
    'Designed for 3-Row Potato Haulm Cutting — Adjustable 24" to 30" Row Spacing',
    'Rotary Blade System — Cuts & Shreds Vines at Ground Level',
    'Clears Fields Faster — Improves Harvester Efficiency by 60%',
    'Heavy Steel Guard Frame — Operator & Crop Safety',
    'Compatible with 40+ HP Tractors, Standard 3-Point Hitch',
    'Reduces Manual Labour — Works 2–3 Acres per Hour',
  ],
  cultivator: [
    'Heavy Duty S-Type Spring Tines — 9 to 13 Count, Boron Steel',
    'Spring-Loaded Tines — Auto-Flexes Over Rocks, Zero Breakage',
    'Adjustable Tine Depth: 10 to 20 cm — All Soil Types',
    'Box Section Main Frame — Maximum Strength & Rigidity',
    'Works for Secondary Tillage, Weed Control & Seedbed Prep',
    'Compatible with 35–65 HP Tractors — Standard 3-Point Hitch',
  ],
  'mini-rotavator': [
    'High Tensile EN Steel L-Type Blades — Same Quality as Full-Size ARV',
    'Ultra-Compact Design — Easy to Transport & Maneuver',
    'Ideal for Small Farms, Kitchen Gardens & Orchards',
    'Works in Narrow Field Rows & Hilly Terrain',
    'Spring-Loaded Safety Hood — Blade Protection System',
    'Compatible with 20–35 HP Mini/Small Tractors',
  ],
};

export const DEFAULT_FEATURES = [
  'Manufactured in India with premium alloy steel',
  'Optimized for Indian soil conditions',
  'Easy attachment with standard PTO',
  'Low maintenance & durable construction',
];

// Product photo galleries
export const PRODUCT_GALLERIES = {
  rotavator: [
    { url: `${S}2736588ffe164191fa9c880572a8e28ea9c07d69de042ce86778f551f3941c47.png`, label: "In Field" },
    { url: `${S}6825d4b954c33c125689ba03e09623f50341622a2b7d42f9586ae079c6f805aa.png`, label: "Showroom" },
    { url: `${S}1885aa036d85d7cb3921135f523c52a865522deafe48fec593520d62e9229b2a.png`, label: "Front View" },
    { url: `${S}4af5d9145a2d8fba73df29dd4a6981cafbf434233c25154183ac18502153f8c7.png`, label: "Side View" },
  ],
  'disk-harrow': [
    { url: `${S}cef886afc06451331fc06e00736d25a8fd8fe7251907f3dca5bcb9db9b1b4fa0.png`, label: "In Field" },
    { url: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/272ccff690271b4f8d93b92d07580e456dd7716d1c774719742f4e7227b2ca27.png", label: "Studio" },
    { url: `${S}cd9e5f9bb04ae8e2f27ac604aa82eee95d77f5a600f7e8dc02e79bca71cd56ce.png`, label: "Detail" },
    { url: `${S}e3175b461268be713479ba75d0d358d40e273b0950e643db43c84c59a3642a38.png`, label: "Sunset" },
    { url: `${S}9eeced006fe2ca9f32e717e121efb4c43cfb1e8b78824128e36c159ab6bd9676.png`, label: "Close Up" },
  ],
  mulcher: [
    { url: `${S}eabde4b31381dc6322f20cd7057a83fe24041160a11f2f504ff3ed0f0e6d5184.png`, label: "In Field" },
    { url: `${S}d707ee7074b49b3ed4102b0ce7e6319b2e5406f4b1fe196dd0f3777604811223.png`, label: "Studio" },
    { url: `${S}6911be18b4ae0557017a6b3f0774800b2413c57a4bec0d72e4e0aadfef4063dc.png`, label: "Action" },
    { url: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/4c6f1ffa438635645e6f50275416fefebb841c770c50ad3b1cb379f8250037d2.png", label: "Harvest" },
  ],
  'fertilizer-spreader': [
    { url: `${S}30d829a4a048519cd09773e6034619082be6a3b25a573a2212c2e3ac8be07f6f.png`, label: "In Field" },
    { url: `${S}8560fdbcdf483bf07fe51e751369e2fd46c7f91539a6306eae298ad1cb103682.png`, label: "Studio" },
    { url: `${S}e86e5d9093ce6d7a4cfe7df03522dd20226a09c0712ce25e3fa03c9039bdfa96.png`, label: "Spreading" },
    { url: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/99e63324192336f1140c60bb6712132264a5fbd420abab1dd200219da84ce341.png", label: "Pattern" },
  ],
  'potato-mulcher': [
    { url: "https://static.prod-images.emergentagent.com/jobs/204fd1ee-d5f5-41fd-b62b-c3d59da90620/images/79755e38c98e28a5fbc8453738bc5150565dc6ea5fea24579f13498803ae7691.png", label: "Side View" },
    { url: "https://static.prod-images.emergentagent.com/jobs/204fd1ee-d5f5-41fd-b62b-c3d59da90620/images/13fab16fe5bb9258ecede53bedaf129c1a39dbd111c136512986a0fefea73acc.png", label: "Rear View" },
  ],
  cultivator: [
    { url: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/4c5c0dde1d9b93f74b0fb8abc1e764130cebabc0bfb040f3ad2fda59de9ee7b3.png", label: "Studio" },
    { url: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/8f908ffdc55e19501cdadac73943b99cfda6664ec14de7e757463f4126c392a1.png", label: "In Field" },
    { url: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/6092209ab11770d989c51d27f820e241d1ecdf7d1623b219d212292438e6e3a5.png", label: "Tines Close-up" },
    { url: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/212d11fe6e0c835f14ed87acde5b28b3c8c4071557173172004b104e80cee92a.png", label: "Front View" },
  ],
  'mini-rotavator': [
    { url: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/db1b02de5fc0f01599b62ff23dfc5039d4eaf40081339965f2d08d144277c38e.png", label: "Front View" },
    { url: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/d712487f22419dcb3fe3d209d2cb627ab2d1acb8af3f8e5cd4fafba98164fc54.png", label: "Top View" },
    { url: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/c05d4dcf60a3cb7ac65422d0433c51312d7787456cf6f450a37234c4b3eea113.png", label: "Side View" },
    { url: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/d3c858866b26eab8248eb555cf326c8ae59f65e387a5048317b98b0ba17f2029.png", label: "Detail" },
  ],
};
